<!--Wird von Bildmobil in der Aktivierung Summary eingebunden-->
<template>
  <div class="activation-data">
    <b-row class="msisdn">
      <b-col md="" sm="12" class="label">
        <slot name="lblMsisdn">Rufnummer:</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{msisdn}}</b-col>
    </b-row>
    <b-row class="activation-code">
      <b-col md="" sm="12" class="label">
        <slot name="lblActivationCode">Aktivierungscode:</slot>
      </b-col>
      <b-col md="" sm="12" class="value">{{activationCode}}</b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { BCol, BRow } from 'bootstrap-vue'

export default {
  name: 'ActivationDataSummary',
  components: { BRow, BCol },
  computed: {
    ...mapGetters('activation/info', [
      'msisdn', 'activationCode'
    ])
  }
}
</script>
